export default "__VITE_ASSET__20c27cfe__"